import React from 'react';
import { TextInput } from '@uhg-abyss/web/ui/TextInput';
import { uniqueId } from 'lodash';
import PropTypes from 'prop-types';

export const LicenseNumber = ({ required, id, model, label, ...props }) => {
  return (
    <React.Fragment>
      <TextInput
        model={model}
        label={label}
        formatter={(value) => {
          return value.replace(/[!@#$%^&*)({}<> ,[\]+`~=\\|';":/?]/g, '');
        }}
        validators={{
          required: (value) => {
            return !value ? 'License number is required.' : '';
          },
        }}
        data-testid="license-number"
        maxLength={20}
        isClearable
        name={`${model}-input-${uniqueId()}`}
        autoComplete="none"
      />
    </React.Fragment>
  );
};
LicenseNumber.propTypes = {
  required: PropTypes.bool,
  id: PropTypes.string,
  model: PropTypes.string.isRequired,
  label: PropTypes.string,
};

LicenseNumber.defaultProps = {
  required: false,
  id: 'licensetype',
  label: 'License Type',
};
